import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="accueil" className="relative w-full overflow-hidden bg-ardis-blue" data-id="element-272" data-mp="ejwjvag6ud6s">
      <div className="relative h-[62vh] min-h-[420px] w-full" data-id="element-273" data-mp="ei1wzqlcwb02">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/4aca4a91-33d5-4f41-8cdc-ef680eb275df.jpg" alt="Intérieur d’un hypermarché moderne avec rayons et espace fruits et légumes" className="absolute inset-0 h-full w-full object-cover" data-id="element-274" data-mp="9ll64omrvija" />
        <div className="absolute inset-0 bg-ardis-blue/65" data-id="element-275" data-mp="xbpd95z660f1" />
        <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col items-center justify-center px-5 text-center" data-id="element-276" data-mp="sb1chsl5257m">
          <motion.h1 initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="font-display text-4xl font-bold text-white drop-shadow-md sm:text-5xl lg:text-6xl" data-id="element-277" data-mp="nb6k1klpt7kg">
            Votre Partenaire en Approvisionnement
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15,
          ease: 'easeOut'
        }} className="mt-5 text-lg font-medium text-white/85 sm:text-2xl" data-id="element-278" data-mp="3j6o8da1vw4lc">
            Qualité et Prix Garantis
          </motion.p>
          <motion.a href="#categories" initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3,
          ease: 'easeOut'
        }} className="mt-8 rounded-full bg-ardis-yellow px-8 py-3.5 font-display text-sm font-semibold text-ardis-green-dark shadow-lg transition-transform hover:scale-105" data-id="element-279" data-mp="30hho3ilfz4xf">
            Découvrir nos produits
          </motion.a>
        </div>
      </div>
    </section>;
}